import MemberContractState from './MemberContractState.js';

export default class Attendee {
    static fromData(data) {
        if (!data) {
            return;
        }

        const attendee = new Attendee();
        attendee.id = data.id;
        attendee.appointmentSeriesId = data.appointmentSeriesId;
        attendee.start = data.start;
        attendee.member = { ...data.member };
        if (data.member?.contractState) {
            attendee.member.contractState = new MemberContractState(
                data.member.contractState.status,
                data.member.contractState.contractType,
            );
        }
        attendee.status = data.status;
        attendee.lastReply = data.lastReply || null;
        attendee.bookingStatus = data.bookingStatus || null;
        attendee.comment = data.comment ?? null;

        return attendee;
    }

    serialize() {
        return {
            id: this.id,
            appointmentSeriesId: this.appointmentSeriesId,
            start: this.start,
            member: this.member.id,
            status: this.status,
        };
    }
}
